import { useContext } from 'react';

import { HeaderVisibilityContext } from '~store/HeaderVisibility/HeaderVisibilityContext';

export function useHeaderVisibility() {
  return useContext(HeaderVisibilityContext);
}
